import { ToastContainer } from 'react-toastify';
import * as Sentry from '@sentry/react';

import { Routing } from 'pages';
import { ENVIRONMENT, PRODUCTION_ENVIRONMENT_NAME } from 'shared/conf/constants';
import { withProviders } from './providers';

import 'react-toastify/dist/ReactToastify.css';

// TODO TEMP REFACTOR
if (ENVIRONMENT !== PRODUCTION_ENVIRONMENT_NAME) {
  window.console.warn = () => {};
  window.console.error = () => {};
}

const App = () => (
  <>
    <Routing />
    <ToastContainer />
  </>
);

export default ENVIRONMENT === PRODUCTION_ENVIRONMENT_NAME
  ? Sentry.withProfiler(withProviders(App))
  : withProviders(App);
